// extracted by mini-css-extract-plugin
module.exports = {"windHolder":"Tabs_windHolder__3u7YY","viewSelector":"Tabs_viewSelector__3NNxR","tabHolder":"Tabs_tabHolder__1Lzs6","fill":"Tabs_fill__gMgDM","groupMenu":"Tabs_groupMenu__3WOGA"};